import React, { useContext, useCallback, useState } from 'react';
import { IEditorProps } from './Editor';
import { uploadFileValue } from '@decisions/server/DecisionsFramework/Design/Properties/PropertyEditorService';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import { EditorLabel } from './EditorLabel';
import { FileUploadArea } from '../FileLoader/Upload/FileUploadArea';
import { IUploadedFileInfo } from '../FileLoader/Upload/FileInfo';
import { getChildValue } from 'components/property-editors/utils/ProviderNodeUtils';
import { FileDataWithReferencePath } from '@decisions/server/DecisionsFramework/Data/DataTypes/FileDataWithReferencePath';
import { EditorValidationWrapper } from './EditorValidationWrapper';

export function FilePickerEditor(props: IEditorProps) {
  const { child, path, onChange } = props;
  const [fileAreaWarningShowing, setFileAreaWarningShowing] = useState(false);
  const { editingContextId } = useContext(PropertyEditorContext);
  const fileData: FileDataWithReferencePath | null = getChildValue(child);
  const length = fileData?.ContentLength || 0;
  let uploadedFile: IUploadedFileInfo[] = [];

  const onComplete = useCallback(
    async (fileInfo: IUploadedFileInfo) => {
      await uploadFileValue({ editingContextId, path, fileReferenceId: fileInfo.fileId });
    },
    [editingContextId, path]
  );

  const resetUploadedFile = useCallback(() => {
    onChange(null, path);
  }, [onChange, path]);

  function getUploadedFileInfo(): IUploadedFileInfo[] {
    if (fileData) {
      let file: IUploadedFileInfo = {
        fileId: fileData.Id,
        fileName: fileData.FileName,
        fileSize: length,
      };
      uploadedFile.push(file);
    }
    return uploadedFile;
  }

  return (
    <EditorLabel htmlFor={props.id} editor={child} path={path} doNotWrap>
      <EditorValidationWrapper editor={child} shouldShow={!fileAreaWarningShowing}>
        <div className="dp-file-editor-holder">
          <FileUploadArea
            reset
            onRemove={resetUploadedFile}
            onComplete={onComplete}
            uploadedFileInfo={getUploadedFileInfo()}
            holderClassName="dp-file-editor-area-holder"
            onFileAreaWarningsShowing={setFileAreaWarningShowing}
          />
        </div>
      </EditorValidationWrapper>
    </EditorLabel>
  );
}
